import { UpgradeOption } from '@journeyapps-platform/types-charging-station';
import { useKeenSlider } from 'keen-slider/react';
import React, { useEffect } from 'react';
import { styled } from '../../../../theme';
import { LoaderSpinner } from '../../../../widgets/LoaderWidget';
import { ButtonType } from '../../../../widgets/buttons/ButtonWidget';
import { GroupedButtons } from '../../../../widgets/buttons/GroupedButtons';
import { FormLayoutWidget } from '../../../../widgets/layout/FormLayoutWidget';
import { EnterpriseUpgradeOptionWidget, UpgradeOptionWidget } from './UpgradeOptionWidget';

export interface SelectPlanStepWidgetProps {
  upgrades: UpgradeOption[];
  selected?: string;
  onSelected: (option: string) => any;
  onNext: () => any;
  onCancel: () => any;
}

export const ENTERPRISE_ID = 'enterprise';

export const SelectPlanStepWidget: React.FC<SelectPlanStepWidgetProps> = (props) => {
  //slider things
  const [sliderRef, instanceRef] = useKeenSlider({
    loop: false,
    mode: 'snap',
    slides: { origin: 'center', perView: 'auto', number: props.upgrades.length + 1, spacing: 15 }
  });
  useEffect(() => {
    if (props.selected != null) {
      if (props.selected === ENTERPRISE_ID) {
        instanceRef.current?.moveToIdx(props.upgrades.length);
      } else {
        instanceRef.current?.moveToIdx(props.upgrades.findIndex((u) => u.id === props.selected));
      }
    }
  }, [props.selected]);

  return (
    <FormLayoutWidget
      sections={[
        {
          key: 'select',
          elements: [
            <S.Wrapper>
              {props.upgrades.length === 0 ? <LoaderSpinner /> : null}
              {props.upgrades.length > 0 ? (
                <S.Container className="keen-slider" ref={sliderRef}>
                  {props.upgrades.map((upgrade, index) => {
                    return (
                      <S.UpgradeOptionContainer
                        className={`keen-slider__slide`}
                        key={upgrade.id}
                        onClick={() => {
                          props.onSelected(upgrade.id);
                        }}
                      >
                        <UpgradeOptionWidget selected={upgrade.id === props.selected} upgrade={upgrade} />
                      </S.UpgradeOptionContainer>
                    );
                  })}
                  <S.UpgradeOptionContainer
                    className={`keen-slider__slide`}
                    key={ENTERPRISE_ID}
                    onClick={() => {
                      props.onSelected(ENTERPRISE_ID);
                    }}
                  >
                    <EnterpriseUpgradeOptionWidget selected={props.selected === ENTERPRISE_ID} />
                  </S.UpgradeOptionContainer>
                </S.Container>
              ) : null}
            </S.Wrapper>
          ]
        },
        {
          key: 'buttons',
          elements: [
            <GroupedButtons
              btns={[
                {
                  type: ButtonType.SECONDARY,
                  label: 'Cancel',
                  action: () => {
                    props.onCancel();
                  }
                },
                {
                  type: ButtonType.PRIMARY,
                  label: 'Next',
                  disabled: !props.selected,
                  action: () => {
                    props.onNext();
                  }
                }
              ]}
            />
          ]
        }
      ]}
    />
  );
};

namespace S {
  export const Wrapper = styled.div`
    max-width: 800px;
    min-width: 800px;
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  export const Container = styled.div``;

  export const UpgradeOptionContainer = styled.div`
    min-width: 550px;
    max-width: 550px;
    cursor: pointer;
  `;
}
